import { Component, HostListener, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ToastService } from "../toast.service";
import { DeviceCheckService } from "../../core/survey/shared/services/device-check.service";

export class NavAction {
  icon: string;
  style?: string;
  tooltip?: string;
  onClick: () => void;
}

@Component({
  selector: "app-top-nav",
  templateUrl: "./top-nav.component.html",
  styleUrls: ["./top-nav.component.scss"],
})
export class TopNavComponent {
  @Input() pageActions: NavAction[] = [];
  @HostListener("window:resize")
  onResize() {
    if (this.deviceCheck.isTouch()) {
      const comp = document.querySelector<HTMLElement>(
        "app-survey-ochestrator > *"
      );
      if (comp) {
        // give the browser a little shake to bring top nav panel back after keyboard closed
        comp.style.position = "absolute";
        setTimeout(() => {
          comp.style.position = "static";
        }, 50);
      }
    }
  }

  constructor(
    private _toastService: ToastService,
    private _router: Router,
    private deviceCheck: DeviceCheckService
  ) {}

  onNavigate(route: string) {
    if (!navigator.onLine) {
      this._toastService.showWarnToast(
        $localize`:@@general.nointernet:No internet`,
        $localize`:@@general.nointernet.actionnotpossible:This action is not possible while you're offline.`
      );
      return;
    }

    this._router.navigate([route]);
  }

  isActive(route: string) {
    return location.href.indexOf(route) != -1;
  }
}
